// @flow
import i18n from "i18next";
import k from "src/i18n/keys";

import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import Checklist from "src/components/Dock/Panels/Checklist";
import ChatHistory from "src/components/messages/History";
import LoadingState from "src/components/LoadingState";
import type { UnifizeChatRoom, AppState } from "src/types";
import Input from "./Input";

import { getProcessLayoutSettings } from "src/reducers";

import {
  Tab,
  TabContainer,
  TabContent,
  TabList,
  TabPanel,
  TabPanelData,
  MandatoryCountBadge,
  TabFooter,
} from "./styles";

type Props = {
  room: UnifizeChatRoom,
  mandatoryFieldCount: number,
  currentUserUid: string,
};

const Tabs = ({ mandatoryFieldCount, room, currentUserUid }: Props) => {
  const checklistLayout = useSelector(({ app }: { app: AppState }) =>
    getProcessLayoutSettings(app, room?.id),
  );

  // Chatroom type is checked to prevent feeds from not rendering chatroom
  // due to lack of checklist layout.
  const isLayoutPresent =
    room?.type === "workflow" ? Boolean(checklistLayout?.checklistWidth) : true;

  const [activeTab, setActiveTab] = useState(0);

  // Update activeTab when activeDock changes (e.g., when app loads)
  useEffect(() => {
    if (checklistLayout && checklistLayout.checklistOpenState?.liteMobile) {
      setActiveTab(1);
    } else {
      setActiveTab(0);
    }
  }, [checklistLayout]);

  return (
    <TabContainer>
      <TabList>
        <Tab active={activeTab === 0} onClick={() => setActiveTab(0)}>
          {i18n.t(k.CONVERSATION1)}
        </Tab>
        <Tab active={activeTab === 1} onClick={() => setActiveTab(1)}>
          {i18n.t(k.CHECKLIST1)}
          {mandatoryFieldCount ? (
            <MandatoryCountBadge>{mandatoryFieldCount}</MandatoryCountBadge>
          ) : null}
        </Tab>
      </TabList>
      <TabContent>
        <TabPanel active={activeTab === 0}>
          <TabPanelData>
            {room && room.id && isLayoutPresent ? (
              <ChatHistory roomId={room.id} />
            ) : (
              <LoadingState type="mobileHistory" />
            )}
          </TabPanelData>
          <TabFooter>
            {room && room.id && currentUserUid && isLayoutPresent ? (
              <Input roomId={room.id} />
            ) : (
              <LoadingState type="input" />
            )}
          </TabFooter>
        </TabPanel>
        <TabPanel active={activeTab === 1}>
          <TabPanelData>
            {room && room.id && <Checklist roomId={room.id} />}
          </TabPanelData>
        </TabPanel>
      </TabContent>
    </TabContainer>
  );
};

export default Tabs;
